import { usePipedriveStore } from "..";
import { showErrorToast, showSuccessToast } from "../components/ToastContainer";

const useDealDelete = (): (id: number) => Promise<void> => {
    const pipedriveStore = usePipedriveStore();

    return async (id: number): Promise<void> => {
        try {
            await pipedriveStore.deleteDeal(id);
            showSuccessToast();
        } catch (e) {
            showErrorToast();
            throw e;
        }
    };
};

export default useDealDelete;